import { generateClasses } from '@formkit/themes'
import { theme, themeIcons } from '@cluber/config-brand/formkit.theme'
import { DefaultConfigOptions } from '@formkit/vue'
import { es, en, ca } from '@formkit/i18n'

const config: DefaultConfigOptions = {
  locale: 'es',
  locales: {
    es,
    en,
    ca,
  },
  config: {
    // pass our theme object to generateClasses
    classes: generateClasses(theme),
  },
  ...themeIcons,
}

export default config